"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
var Location = /** @class */ (function () {
    function Location() {
    }
    /**
     * URL解析して、クエリ文字列を返す
     * @returns {Array} クエリ文字列
     */
    Location.getUrlVars = function () {
        var vars = {};
        var max = 0;
        var url = window.location.search;
        if (url !== '') {
            // ?を取り除くため、1から始める。複数のクエリ文字列に対応するため、&で区切る
            var hash = url.slice(1).split('&');
            max = hash.length;
            for (var i = 0; i < max; i++) {
                var array = hash[i].split('='); // keyと値に分割。
                var key = array[0];
                vars[key] = decodeURIComponent(array[1]); // 先ほど確保したkeyに、値を代入。
            }
        }
        return vars;
    };
    return Location;
}());
exports.Location = Location;
//# sourceMappingURL=Location.js.map